import { SETTINGS } from '../../config/settings';

const urlClubePublicationWeb = SETTINGS.public.urlClubePublicationWeb;
const urlClubeParcerias = SETTINGS.public.urlClubeParcerias;
const urlPlanWeb = SETTINGS.public.urlPlanWeb;
const urlMedicationsWeb = SETTINGS.public.urlMedicationsWeb;
const urlPosthumousWeb = SETTINGS.public.urlPosthumousWeb;
const urlMedicalPartnerWeb = SETTINGS.public.urlMedicalPartnerWeb;
const urlAuthWeb = SETTINGS.public.urlAuthWeb;
const urlContractWeb = SETTINGS.public.urlContractLegacyWeb;
const urlAccountWeb = SETTINGS.public.urlAccountWeb;
const urlHubWeb = SETTINGS.public.urlHubWeb;
const urlTelevetWeb = SETTINGS.public.urlTelevetWeb;
const urlBillingWeb = SETTINGS.public.urlBillingWeb;
const urlTermWeb = SETTINGS.public.urlTermWeb;

export const AUTH = urlAuthWeb;
export const ACCOUNT = urlAccountWeb;
export const HUB = urlHubWeb;

export const HUB_HOME = `${HUB}/home`;
export const ACCOUNT_PROFILE = `${AUTH}/profile`;

export const CLUBE = urlClubePublicationWeb;

export const CLUBE_PARCERIAS = `${urlClubeParcerias}/categoria`;

export const MEDICAL_PARTNER = urlMedicalPartnerWeb;

export const CONTRACT = urlContractWeb;

export const PLAN = urlPlanWeb;

export const MEDICATIONS = urlMedicationsWeb;

export const POSTHUMOUS = urlPosthumousWeb;

export const TELEVET = urlTelevetWeb;

export const BILLING = urlBillingWeb;

export const TERM = urlTermWeb;
